var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4190 4793c-35-14-72-47-88-80l-18-35-426-122c-412-117-427-121-448-104-80 65-213 12-242-95-7-26-15-47-19-47s-200-110-435-245c-420-240-429-245-462-234-45 15-104 6-140-20-16-11-31-19-33-17-7 7-808 236-824 236-8 0-21 15-29 33-41 99-172 127-250 54-70-66-70-168 0-234 53-49 143-56 194-15 21 17 36 13 447-104 423-121 425-122 441-154 33-69 121-105 195-81 45 15 94 70 103 115 6 34 17 41 446 287 401 230 442 251 464 240 33-15 78-14 117 3 35 14 87 69 87 91 0 8 8 16 18 19 9 3 199 58 422 121 223 64 407 118 409 120 2 3 18-6 35-18 42-30 133-31 172-1 53 39 69 71 69 134s-16 95-67 133c-27 20-110 32-138 20z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3945 3815-25-24v-1496-1495h-240-240v1335 1336l-25 24-24 25h-271-271l-24-25-25-24v-1336-1335h-240-240v1015 1016l-25 24-24 25h-271-271l-24-25-25-24v-1016-1015h-240-240v1175 1176l-25 24-24 25h-271-271l-24-25-25-24v-1176-1175h-95c-88 0-98-2-120-25-25-24-25-26-25-215s0-191 25-215l24-25h2191 2191l24 25c25 24 25 26 25 215s0 191-25 215c-22 23-32 25-120 25h-95v1495 1496l-25 24-24 25h-271-271z",
    fill: "#c4c4c4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statistics-icon.c6c9e8596dfba5199ba402f765a700d8.svg";
export { ForwardRef as ReactComponent };